const
  UserTypes = Object.freeze({
    ANONYMOUS: 'anonimo'
  }),
  Genders = Object.freeze({
    FEM: 'f',
    MAS: 'm'
  })
;

const {$} = Voonto;

Voonto.ready.then((app) => {
  app.when('vocuser:ready').then((gigyaux) => {

    if (gigyaux.getUserType() === UserTypes.ANONYMOUS) {
      $('head').append(`<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=76171930?" width="1" height="1" border="0" />`);
    } else {
      $('head').append(`<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=76172050?" width="1" height="1" border="0" />`);

      app.when('vocuser:userdata').then((userdata) => {
        var gender, age;

        gender = userdata.responseGetUserInfo.user.gender;
        age    = userdata.responseGetUserInfo.user.age;

        switch (gender) {
          case Genders.FEM:
            $('head').append(`<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=75868810?" width="1" height="1" border="0" />`);
            break;
          case Genders.MAS:
            $('head').append(`<img src="' + urlProtocol + '://pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=75868570?" width="1" height="1" border="0" />`);
            break;
        }

        switch (true) {
          case '' !== age && 17 >= age:
            $('head').append(`<img src="' + urlProtocol + '://pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=75867610?" width="1" height="1" border="0" />`);
            break;
          case 18 <= age && 24 >= age:
            $('head').append(`<img src="' + urlProtocol + '://pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=75867850?" width="1" height="1" border="0" />`);
            break;
          case 25 <= age && 34 >= age:
            $('head').append(`<img src="' + urlProtocol + '://pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=75867970?" width="1" height="1" border="0" />`);
            break;
          case 35 <= age && 44 >= age:
            $('head').append(`<img src="' + urlProtocol + '://pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=75868210?" width="1" height="1" border="0" />`);
            break;
          case 45 <= age && 54 >= age:
            $('head').append(`<img src="' + urlProtocol + '://pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=75868330?" width="1" height="1" border="0" />`);
            break;
          case '' !== age && 54 > age:
            $('head').append(`<img src="' + urlProtocol + '://pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=75868450?" width="1" height="1" border="0" />`);
            break;
        }
      });
    }
  });
});

/* Private */

function _ord() {
  return Math.random() * 10000000000000;
}



// WEBPACK FOOTER //
// ./src/dfp-pixel.js